/**
 * Shown to signed-in users who hold no BOP role. Must stay public so the
 * middleware access check does not redirect it to itself.
 */
export const ACCESS_DENIED_PATH = '/access-denied';

/**
 * Public pages that do not require authentication.
 * These pages are accessible without a valid session.
 */
export const PUBLIC_PAGE_PATHS = [
  '/404',
  ACCESS_DENIED_PATH,
  '/signin',
  '/docs',
  '/docs/getting-started',
  '/docs/commercial-api',
  '/docs/api-terms',
];

/**
 * Checks if a given pathname is a public page (does not require authentication).
 */
export function isPublicPage(pathname: string): boolean {
  return PUBLIC_PAGE_PATHS.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/'),
  );
}
